import Player from '../Player';
import PlayerAudio from './PlayerAudio';
import PlayerPodcast from './PlayerPodcast';
import PlayerMinutaminutAudio from './PlayerMinutaminutAudio';
import PlayerPopupAudio from './PlayerPopupAudio';
import PlayerReels from './PlayerReels';
import PlayerTTS from './PlayerTTS';
import PlayerAudioRelacionat from './PlayerAudioRelacionat';
import PlayerDestacat from './PlayerDestacat';
import PlayerAnimat from './PlayerAnimat';

export default function Component(props) {
    const { id, tipus, imatges } = props;

    switch (tipus) {
        case 'video-directe':
            return (
                <Player
                    {...props}
                    id={id}
                    estils='minutaminutVideo'
                    playerVideoTagId={`${props.tagIdPrefix}-video-directe-${id}`}
                    accessibilitat={false}
                    eliminarPrimerTabIndex={true}
                    imatges={imatges}
                    directe={true}
                />
            );
        case 'minut-a-minut-audio':
            return (
                <PlayerMinutaminutAudio
                    id={id}
                    autoPlay={true}
                    imatges={imatges}
                    playerVideoTagId={`minut-a-minut-audio-${id}`}
                />
            );
        case 'audioNotiRelacionat':
            return <PlayerAudioRelacionat {...props} />;
        case 'audioNoti':
            return <PlayerAudio {...props} />;
        case 'podcast':
            return <PlayerPodcast {...props} />;
        case 'reels':
            return <PlayerReels {...props} />;
        case 'popup-audio':
            return <PlayerPopupAudio {...props} />;
        case 'tts':
            return <PlayerTTS {...props} />;
        case 'destacat':
            return <PlayerDestacat {...props} />;
        case 'videoAnimat':
            return <PlayerAnimat {...props} />;
        default:
            return <Player {...props} />;
    }
}
